module.exports = __webpack_public_path__ + "assets/img/2.ae10b125.jpg";